import { Switch, Route, Redirect } from "react-router-dom";
import NewPharmacy from "./New";
import EditPharmacy from "./Edit";
import ListPharmacy from "./List";
import Error from "../../components/Error";

const Component = ({ admin, therapist, props }) => {
  const path = "/pharmacy";

  return (
    <div className="frame pb-3">
      <Switch>
        <Route
          exact
          path={`${path}`}
          render={() =>
            admin || therapist ? <ListPharmacy infoRoute={props} /> : <Error />
          }
        />
        <Route
          path={`${path}/new`}
          render={() =>
            admin || therapist ? <NewPharmacy infoRoute={props} /> : <Error />
          }
        />
        <Route
          path={`${path}/:id`}
          render={() =>
            admin || therapist ? <EditPharmacy infoRoute={props} /> : <Error />
          }
        />
        <Route
          exact
          path={`${path}/*`}
          render={() => <Redirect to={"/404"} />}
        />
      </Switch>
    </div>
  );
};

export default Component;
